import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronMinimizeDiagonalFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.75,7h-3.75V3.25c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75V7.75c0,.414,.336,.75,.75,.75h4.5c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M7.75,9.5H3.25c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h3.75v3.75c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-4.5c0-.414-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconChevronMinimizeDiagonalFill18.js.map